import mongoose from 'mongoose';
import schema, { ICustomerEmailMappingDocument } from '../schemas/customer-email-mapping';

const CustomerEmailMapping = (mongoose.models.CustomerEmailMapping ||
  mongoose.model('CustomerEmailMapping', schema)) as mongoose.Model<ICustomerEmailMappingDocument>;

export default CustomerEmailMapping;
